import { Link } from '@nike/eds'
import { Link as RouterLink } from 'react-router-dom'
import { HTMLProps, PropsWithChildren } from 'react'

type AnchorHtmlPropsAndChildren = PropsWithChildren<HTMLProps<HTMLAnchorElement>>

export interface PageLinkProps extends AnchorHtmlPropsAndChildren {
  pathPrefix: string
  id: string
}

export function PageLink({ pathPrefix, id, children = undefined, style = {} }: PageLinkProps) {
  return (
    <Link
      style={{
        display: 'inline',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        ...style,
      }}
      as={RouterLink}
      to={`${pathPrefix}${encodeURIComponent(id)}`}
    >
      {children || id}
    </Link>
  )
}

export function ShipmentLink({
  packlistNumber,
  ...otherProps
}: { packlistNumber: string } & AnchorHtmlPropsAndChildren) {
  return <PageLink pathPrefix="/shipment/" id={packlistNumber} {...otherProps} />
}

export function GoodsHolderLink({
  goodsHolderNumber,
  ...otherProps
}: { goodsHolderNumber: string } & AnchorHtmlPropsAndChildren) {
  return <PageLink pathPrefix="/carton/" id={goodsHolderNumber} {...otherProps} />
}
